import { render, staticRenderFns } from "./WorkshopMain.vue?vue&type=template&id=3e430bdc"
import script from "./WorkshopMain.vue?vue&type=script&lang=js"
export * from "./WorkshopMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports